import { Box, PropTypes, useTheme } from '@mui/material';
import HeartCheckIcon from '../HeartCheckIcon';
import HeartPlusIcon from '../HeartPlusIcon';

type PropTypes = {
  isAdded: boolean;
};
const AddToLibraryIcon = ({ isAdded }: PropTypes) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{
        '& svg': {
          width: theme.spacing(3),
          height: theme.spacing(3),
        },
      }}
    >
      {!isAdded ? (
        <HeartPlusIcon />
      ) : (
        <HeartCheckIcon color={theme.palette.primary.main} />
      )}
    </Box>
  );
};
export default AddToLibraryIcon;
